import { t } from '@lingui/macro';
import { object, string } from 'yup';

export const saveSelectedSitesListValidationSchemaFn = () =>
  object().shape({
    name: string()
      .required(`${t`Provide a name for new list`}`)
      .test('len', t`Name should contain between 3 to 50 characters`, (val) => val?.length >= 3 && val?.length <= 50),
  });
